import { Create,  Detail, Detail_v1, List } from "./views";

const Module = {
    name: "imports",
    defaultRoutePath: "/imports",

    routes: [
        
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        {
            path: "detail_v1",
            Component: Detail_v1,
        },
        {
            path: "create",
            Component: Create,
        },
    ],
   
}

export default Module;
